import React, { Fragment, useState } from 'react'
import { ListGroup } from 'react-bootstrap'
import userimg from '../../Assets/Images/user.png'
import { Form } from 'react-bootstrap'
import MyProfileScreen from './MyProfileScreen'
import MyAddressTab from './MyAddressTab'
import MyOrderTab from './MyOrderTab'
import MySubscriptionTab from './MySubscriptionTab'
import MyCardDetailTab from './MyCardDetailTab'
import { useDispatch, useSelector } from 'react-redux'
import avatar from "../../Assets/Images/avatar.jpg";
import { logout } from '../../Redux/Slice/Auth/authSlice'
import { useNavigate } from 'react-router-dom'
import { removeAllCart } from '../../Redux/Slice/Cart/cartSlice'


const ProfileDetail = () => {

    const [tabs, setTabs] = useState("personalInfo")
    const { user } = useSelector((state) => state.user)

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const handleLogout = async () => {
        dispatch(logout());
        dispatch(removeAllCart())

        navigate('/login')
    }

    return (
        <Fragment >
            <div className="container my-5">
                <div className="row py-5">
                    <div className="col-lg-4">
                        <ListGroup >
                            <ListGroup.Item as="li" className='bg-danger border-danger py-2' active>
                                <div className="row align-items-center">
                                    <div className="col-auto">
                                        {
                                            user?.userimg ? (

                                                < img src={user?.userimg} alt="" />
                                            ) : (

                                                <img src={userimg} alt="" />
                                            )
                                        }
                                    </div>
                                    <div className="col-auto ps-0">
                                        <h4 className='text-capitalize s-28 mb-0 text-white'>
                                            {user?.name} {" "}

                                            <span className='test-capitalize'>
                                                {user?.last_name}
                                            </span>
                                        </h4>
                                    </div>

                                    <div className="col ">
                                        <p onClick={handleLogout} className='cursor-pointer text-light text-end mb-0 s-15'>Logout</p>
                                    </div>
                                </div>
                            </ListGroup.Item>

                            <ListGroup.Item className={`${tabs === "personalInfo" ? "bg-light text-dark" : ""} border-bottom-0 py-0`} action onClick={() => setTabs("personalInfo")}>
                                <p className='border-bottom py-3 mb-0 fw-500'>
                                    My Account
                                </p>
                            </ListGroup.Item>
                            <ListGroup.Item className={`${tabs === "myAddress" ? "bg-light text-dark" : ""} border-bottom-0 py-0`} action onClick={() => setTabs("myAddress")}>
                                <p className='border-bottom py-3 mb-0 fw-500'>
                                    My Address
                                </p>
                            </ListGroup.Item>
                            <ListGroup.Item className={`${tabs === "myOrders" ? "bg-light text-dark" : ""} border-bottom-0 py-0`} action onClick={() => setTabs("myOrders")}>
                                <p className='border-bottom py-3 mb-0 fw-500'>
                                    My Orders
                                </p>
                            </ListGroup.Item>
                            <ListGroup.Item className={`${tabs === "mySubscription" ? "bg-light text-dark" : ""} border-bottom-0 py-0`} action onClick={() => setTabs("mySubscription")}>
                                <p className='border-bottom py-3 mb-0 fw-500'>
                                    My Subscription
                                </p>
                            </ListGroup.Item>
                            <ListGroup.Item className='py-0' action onClick={() => setTabs("myCardDetail")}>
                                <p className='fw-500 py-3 mb-0'>
                                    My Card Detials
                                </p>
                            </ListGroup.Item>
                        </ListGroup>
                    </div>

                    <div className="col-lg-1 " />

                    <div className="col-lg-6 mt-4">
                        {tabs === "personalInfo" && (
                            <MyProfileScreen />
                        )}


                        {tabs === "myAddress" && (
                            <MyAddressTab />
                        )}

                        {tabs === "myOrders" && (
                            <MyOrderTab />
                        )}
                        {tabs === "mySubscription" && (
                            <MySubscriptionTab />
                        )}
                        {tabs === "myCardDetail" && (
                            <MyCardDetailTab />
                        )}
                    </div>
                </div>
            </div>
        </Fragment >
    )
}

export default ProfileDetail